import Image from 'next/image';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import { Container } from 'react-bootstrap';
import { dataLayerSendEvent } from '../../../Epharmacy/EpharmacyAnalytics';
import { getReplaceHtmlTags, MIN_MOBILE_WIDTH, getImageSrc } from '../../Utility/common-utils';
import { ONE_ASTER_CATEGORY, ONE_ASTER_CATEGORY_HOME, PAGE_TITLES } from '../../Utility/constants';
import { sendEventToSmartLook } from '../../Utility/smartlook';
import SlickSlider from '../SlickSlider/SlickSlider';
import { BannerSliderWithImageStyled } from './BannerSliderWithImageStyled';
import BannerSliderItem from './BannerSliderItem';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const BannerSliderWithImage = (props) => {
  let autoplaySpeed = 8000;
  let variableWidth = false;
  if (['plp banner'].includes(props?.sectionName)) {
    autoplaySpeed = 4000;
    variableWidth = true;
  }
  if (['dynamic'].includes(props?.sectionName)) {
    autoplaySpeed = 4000;
    variableWidth = true;
  }
  const { data, analyticsProps } = props;
  const router = useRouter();
  const inViewRef = useRef();
  const generateURL = useNavigationURL();

  const bannerViewEventFired = useRef();
  const commonAnalytics = {
    screen_name:
      analyticsProps?.screenName ||
      (router?.query?.slugname
        ? router?.query?.slugname
        : props?.pageName === ONE_ASTER_CATEGORY_HOME?.PHARMACY
        ? 'epharmacy homepage'
        : props?.pageName === ONE_ASTER_CATEGORY_HOME?.CORE
        ? 'asco homepage'
        : props?.pageName === ONE_ASTER_CATEGORY_HOME?.DOCTOR
        ? 'doctor consult homepage'
        : props?.pageName),
    page_type: analyticsProps?.pageType || props?.pageType,
    referrer_page: analyticsProps?.referrerPage || props?.referrerPage,
  };

  const [topBanner] = useState(data);
  const [windowWidth, setWindowWidth] = useState();

  const responsive = [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        variableWidth: variableWidth,
        autoplay: true,
        infinite: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        variableWidth: variableWidth,
        autoplay: true,
        infinite: true,
        ...((props?.homePage === 'Core' || props?.homePage === 'Teleconsult') && {
          slidesToShow: 1,
          variableWidth: false,
          autoplay: true,
          infinite: true,
        }),
      },
    },
  ];

  const onBannerClick = (item) => {
    let screen_name_='';
    if(props?.catId){
      screen_name_=props?.catId;
    } 
    else{
      screen_name_=props?.brandId;
    }
    const bannerProps = {
      banner_name: props?.sectionName === 'plp banner' ? props?.sectionName : 
      props?.sectionName === 'dynamic' ? 'Crossmodule Component' : props?.sectionName,
      banner_url: props?.sectionName === 'plp banner' ? item?.imageWeb : item?.imageWeb,
      banner_position:
        props?.sectionName === 'plp banner' || props?.sectionName === 'dynamic' ? item?.position : item?.order,
      banner_id: item?.bannerName
        ? item?.bannerName
        : props?.sectionName === 'plp banner' || props?.sectionName === 'dynamic'
        ? ''
        : item?.name
        ? item?.name + '_' + item?.id
        : getReplaceHtmlTags(item?.altText) + '_' + item?.id,
      banner_title:
        props?.sectionName === 'plp banner' || props?.sectionName === 'dynamic'
          ? item?.bannerName
          : item?.name
          ? item?.name + '_' + item?.order
          : getReplaceHtmlTags(item?.altText) + '_' + item?.order,
    };
    if (analyticsProps && Object.keys(analyticsProps).length !== 0) {
      dataLayerSendEvent('banner_click', { ...analyticsProps, ...bannerProps });
    } else {
      dataLayerSendEvent('banner_click', { ...commonAnalytics, ...bannerProps });
    }
    const properties = {
      type: props?.pageName,
    };
    sendEventToSmartLook('banner_click', properties);
    if (item?.linkWeb !== '') {
      if (item?.linkWeb?.indexOf('http') === -1) {
        if (item?.linkWeb?.includes('?')) {
          router.push({
            pathname: generateURL(item?.linkWeb.split('?')[0]),
            query: item?.linkWeb.split('?')[1],
          });
        } else {
          router.push({
            pathname: generateURL(item?.linkWeb),
          });
        }
      } else {
        window.open(generateURL(item?.linkWeb), '_self');
      }
    }
  };

  const setting = (slideLength) => {
    let autoplaySpeed = 8000; 
    let variableWidth = false;
    if (['plp banner'].includes(props?.sectionName)) {
      autoplaySpeed = 4000;
      variableWidth = true;
    }
    if (['dynamic'].includes(props?.sectionName)) {
      autoplaySpeed = 4000;
      variableWidth = true;
    }
    if (slideLength === 1) {
      return {
        responsive: responsive,
        slidesToShow: 1,
        variableWidth: variableWidth,
        autoplay: true,
        infinite: false,
        adaptiveHeight: true,
        speed: 500,
        className: 'single-slide',
        autoplaySpeed: autoplaySpeed,
        arrows: false,
      };
    } else {
      return {
        responsive: responsive,
        slidesToShow: 1,
        variableWidth: variableWidth,
        autoplay: true,
        infinite: true,
        adaptiveHeight: true,
        speed: 500,
        className: '',
        autoplaySpeed: autoplaySpeed,
        arrows: true,
      };
    }
  };

  useEffect(() => {
    setWindowWidth(window.innerWidth);
  }, []);

  const onBannerArrowClick = (slideArrow = '') => {
    let currentSlide = document?.querySelector('.slick-slide.slick-active.slick-current');
    let index = Number(currentSlide?.getAttribute('data-index'));
    dataLayerSendEvent('banner_navigation_click_common', {
      screen_name: props?.pageName,
      banner_position: topBanner[index]?.order,
      banner_page_slot: 'Top',
      banner_id: topBanner[index]?.name
        ? topBanner[index]?.name
        : getReplaceHtmlTags(topBanner[index]?.altText),
      banner_title: topBanner[index]?.name
        ? topBanner[index]?.name + '_' + topBanner[index]?.order
        : getReplaceHtmlTags(topBanner[index]?.altText) + '_' + topBanner[index]?.order,
      banner_arrow_navigation: slideArrow,
    });
  };

  useEffect(() => {
    let nextArrow = null;
    let prevArrow = null;
    if (['Top Banner'].includes(props?.sectionName)) {
      nextArrow = document?.querySelector('.slick-arrow.slick-next');
      if (nextArrow) {
        const direction = 'right';
        nextArrow?.addEventListener('click', () => {
          setTimeout(() => {
            onBannerArrowClick(direction);
          }, 1000);
        });
      }
      prevArrow = document?.querySelector('.slick-arrow.slick-prev');
      if (prevArrow) {
        const direction = 'left';
        prevArrow?.addEventListener('click', () => {
          setTimeout(() => {
            onBannerArrowClick(direction);
          }, 1000);
        });
      }
    }
    return () => {
      nextArrow?.removeEventListener('click', () => {});
      prevArrow?.removeEventListener('click', () => {});
    };
  }, []);

  const viewedItemsEvent = new Set();

  const generateBannerId = (responseData) => {
    if (responseData?.bannerName) {
      return responseData.bannerName;
    }
    if (responseData?.name) {
      return `${responseData.name}_${responseData.id}`;
    }

    return `${getReplaceHtmlTags(responseData?.altText)}_${responseData.id}`;
  };

  const generateBannerTitle = (responseData) => {
    if (responseData?.bannerName) {
      return responseData.bannerName;
    }
    if (responseData?.name) {
      return `${responseData.name}_${responseData.order}`;
    }

    return `${getReplaceHtmlTags(responseData?.altText)}_${responseData.order}`;
  };

  const sendBannerImpressionEvent = (responseData) => {
    if (responseData) {
      responseData.forEach((item) => {
        const itemId = generateBannerId(item);
        if (!viewedItemsEvent.has(itemId)) {
          viewedItemsEvent.add(itemId);
          dataLayerSendEvent('banner_impression', {
            ...commonAnalytics,
            myaster_category: analyticsProps?.myaster_category,
            banner_name: props?.sectionName,
            banner_url: item?.imageWeb,
            banner_position: Number(item?.order || item?.position),
            banner_id: itemId,
            banner_title: generateBannerTitle(item),
          });
        }
      });
    }
  };
  const viewedItems = useRef(new Set());

  const [filteredData, setFilteredData] = useState(data);

  const handleBannerVisibilityChange = (itemId, isVisible) => {
    if (!isVisible) {
      const updatedData = filteredData.filter((item) => item.order !== itemId);
      const reOrderedData = updatedData.map((item, index) => {
        return {
          ...item,
          order: index + 1,
        };
      });
      setFilteredData(reOrderedData);
    }

  };

  useEffect(() => {

    // Code for removing the specific banner from Hero Banner Slides
    // After the offer is over

    const currentTime = new Date().getTime();
  
    const updatedData = data?.filter((item, index) => {
      const showTimer = filteredData?.[index]?.showTimer;
      if (!showTimer) { return true; }
  
      const endTime = new Date(filteredData[index]?.endLaunchDateTime).getTime();
      const remainingTime = endTime - currentTime;
      return remainingTime > 0;
    });
  
    setFilteredData(updatedData);

  }, [data]);

  return (
    <BannerSliderWithImageStyled
      ref={inViewRef}
      bgColor={props?.bgColor}
      isHeroPromoBanner={props?.isHeroPromoBanner}
      className={data?.appVariant || props?.appVariant}
      dataLength={(data || []).length}
    >
      <Container>
        <SlickSlider sliderSettings={setting(data?.length)}>
          {filteredData?.map((item, index) => (
              <BannerSliderItem
                onBannerClick={onBannerClick}
                key={item.order}
                item={item}
                onView={(item) => {
                  const itemId = generateBannerId(item);
                  if (!viewedItems.current.has(itemId)) {
                    sendBannerImpressionEvent([item]);
                    viewedItems.current.add(itemId);
                  }
                }}
                pageName={props?.pageName}
                sectionName={props?.sectionName}
                objectCategoryItems={filteredData[index]}
                onVisibilityChange={handleBannerVisibilityChange}
              />
          ))}
        </SlickSlider>
      </Container>
    </BannerSliderWithImageStyled>
  );
};

BannerSliderWithImage.propTypes = {
  appVariant: PropTypes.string,
  data: PropTypes.any,
  setLoading: PropTypes.any,
  bannerSliderApi: PropTypes.any,
  isReload: PropTypes.bool,
  pageName: PropTypes.string,
  sectionName: PropTypes.string,
  homePage: PropTypes.string,
  analyticsProps: PropTypes.object
};

export default BannerSliderWithImage;
